var _circle, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLandRumaenien(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFD200",
    cx: 18,
    cy: 18,
    r: 15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#24356a",
    d: "M13,3.85 C7.18,5.91 3,11.47 3,18 C3,24.53 7.18,30.09 13,32.15"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#e42a18",
    d: "M23,32.15 C28.83,30.09 33,24.53 33,18 C33,11.47 28.83,5.91 23,3.85"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandRumaenien);
export default __webpack_public_path__ + "static/media/land_rumaenien.1ffa18d07c68c0b6f2f25df64905f224.svg";
export { ForwardRef as ReactComponent };